import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query analytic_hourlyDistribution($branchId: ID!, $startTime: DateTime!, $endTime: DateTime!) {
    analytic_reservation_hourlyDistribution(branchId: $branchId, startTime: $startTime, endTime: $endTime) {
      hour
      reservationCount
      guestCount
    }
  }
`);

export default function useReservationHourlyDistribution(branchId: string, startTime: string, endTime: string) {
  return useQuery(QUERY, {
    variables: { branchId, startTime, endTime },
  });
}
